import { Create, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import CreateForm from "./CreateForm";

const CreateExamCommittiee = () => {
  return (
    <Create
      title="Създаване на изпитна комисия"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <CreateForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateExamCommittiee;
